import React from 'react';
import PropTypes from 'prop-types';

import ContentArea from 'components/content-area';
import ContentAreaItem from 'components/content-area-item';
import SearchResult from 'components/search-result';
import Icon from 'components/icon';

const icons = {
  mail: 'mail-thick',
  document: 'document'
};

const SearchResultGroup = ({ htmlId, results, title, iconName }) => (
  <div className="search-result-group">
    <div className="search-result-group--title" id={htmlId}>
      {title && <h2>{title}</h2>}
      {icons[iconName] && <Icon name={icons[iconName]} />}
    </div>
    <div className="search-result-group--items">
      <ContentArea
        additionalItemProps={{
          SearchResult: {
            theme: ContentAreaItem.themes.noMargin
          },
          EmployeeSearchResult: {
            theme: ContentAreaItem.themes.noMargin
          }
        }}
        additionalComponentProps={{
          SearchResult: {
            headingLevel: 2,
            theme: SearchResult.themes.darkText
          }
        }}
        {...results}
      />
    </div>
  </div>
);

SearchResultGroup.defaultProps = {
  results: []
};

SearchResultGroup.propTypes = {
  htmlId: PropTypes.string,
  results: PropTypes.exact(ContentArea.propTypes),
  title: PropTypes.string,
  iconName: PropTypes.oneOf(Object.keys(icons))
};

export default SearchResultGroup;
